import React from 'react';
import { Container } from 'react-bootstrap';
import { AiOutlineFundProjectionScreen } from 'react-icons/ai';
import { FcOnlineSupport } from 'react-icons/fc';
import { ImHappy } from 'react-icons/im';
import { RiTeamFill } from 'react-icons/ri';
import './DoneProject.css';



const DoneProject = () => {
    return (
       <div class="counts pt-5 pb-5">
       <Container>
          <div class="section-title mt-5 pb-3">
            <p className="text-white text-start fs-5">Quick Summary</p>
            <h3 className="pb-4 overView text-start">Overview</h3>
          </div>
        <div class="row">
        <div  class="col-lg-3 col-md-6" data-aos="fade-right" data-aos-offset="300" data-aos-easing="ease-in-sine">
          <div class="count-box">
            <ImHappy style={{fontSize: '40px', color: 'white'}}/>
            <span data-toggle="counter-up">112</span>
            <h6 class="text-Color pt-2">HaPpY Client</h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 mt-5 mt-md-0" data-aos="zoom-in-right">
          <div class="count-box">
          <AiOutlineFundProjectionScreen style={{fontSize: '40px', color: 'white'}}/>
            <span data-toggle="counter-up">115</span>
            <h6 class="text-Color pt-2">Projects Done</h6>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 mt-5 mt-lg-0" data-aos="zoom-in-left">
         <div class="count-box">
           <FcOnlineSupport style={{fontSize: '40px', color: 'white'}}/>
           <span data-toggle="counter-up">1200</span>
           <h6 class="text-Color pt-2">Support Hours</h6>
         </div>
        </div>
  
        <div class="col-lg-3 col-md-6 mt-5 mt-lg-0" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">
          <div class="count-box">
            <RiTeamFill style={{fontSize: '40px', color: 'white'}}/>
            <span data-toggle="counter-up">12</span>
            <h6 class="text-Color pt-2">Coraboration</h6>
          </div>
        </div>
  
         </div>
       </Container>
     </div>
    );
};

export default DoneProject;